import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { ClienteinfoService } from './clienteinfo.service';
import { LocalSaveService } from './local-save-service.service';
import { CitaTentativaModalComponent } from '../home/cita-tentativa-modal/cita-tentativa-modal.component';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CitaTentativaHelperService {
    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private router: Router,
        private clienteinfo: ClienteinfoService,
        private localSave: LocalSaveService,
        private snackbar: MatSnackBar
    ) {}

    /**
     * Carga la tentativa pendiente del cliente, abre el modal si existe, y maneja la accion del usuario.
     * Si el usuario presiona "Atender cliente", configura el cliente activo y navega a homeagente/atencionclientefib.
     *
     * @param idCliente id del cliente cuya tentativa se va a mostrar
     * @param telefono telefono del cliente, para configurar clienteactivo
     * @param idcampana id de la campana, para configurar clienteactivo (default 199)
     * @param mostrarBotonAtender si false oculta el boton "Atender cliente" (vista supervisor)
     * @param idContactoIsoft id del contacto en cwp_contacto_isoft, para busqueda precisa de tentativa
     * @param cuenta codigo de cuenta (account_id), para busqueda por clave de negocio
     * @param contextoFIB campos extra del registro FIB para sembrar en clienteactivo al atender
     */
    async openTentativaParaCliente(idCliente: number, telefono: string, idcampana: number = 199, mostrarBotonAtender: boolean = true, idContactoIsoft?: number, cuenta?: string, contextoFIB?: any): Promise<void> {
        if (!idCliente && !idContactoIsoft && !cuenta) {
            this.snackbar.open('No se puede abrir la tentativa: identificador faltante.', 'Cerrar', { duration: 3000 });
            return;
        }
        try {
            let url: string;
            if (cuenta) {
                url = `${environment.baseUrlPGV}/api/v3/citas-tentativas/by-cuenta/${cuenta}`;
            } else if (idContactoIsoft) {
                url = `${environment.baseUrlPGV}/api/v3/citas-tentativas/by-contacto/${idContactoIsoft}`;
            } else {
                url = `${environment.baseUrlPGV}/api/v3/citas-tentativas/by-cliente/${idCliente}`;
            }
            const headers = { 'Authorization': 'p ' + this.localSave.get('OSR_TKN') };
            const resp: any = await this.http.get<any>(url, { headers }).toPromise();
            if (!resp || resp.response !== 1 || !resp.result) {
                this.snackbar.open('El cliente no tiene una tentativa pendiente.', 'Cerrar', { duration: 3000 });
                return;
            }
            const dialogRef = this.dialog.open(CitaTentativaModalComponent, {
                data: { ...resp.result, mostrarBotonAtender },
                maxWidth: '480px',
                width: '90%'
            });
            const action = await dialogRef.afterClosed().toPromise();
            if (action === 'atender') {
                const usuario = this.localSave.get('usuarioPGV');
                const idagente = usuario ? usuario.idagente : null;
                const clienteactivo: any = { idcliente: idCliente, telefono: telefono, idcampana: idcampana };
                if (contextoFIB) {
                    if (contextoFIB.idContactoFIB != null) { clienteactivo.idContactoFIB = contextoFIB.idContactoFIB; }
                    if (contextoFIB.idEstadoDeEntradaFIB != null) { clienteactivo.idEstadoDeEntradaFIB = contextoFIB.idEstadoDeEntradaFIB; }
                    if (contextoFIB.intento_bloqueado_hoy != null) { clienteactivo.intento_bloqueado_hoy = contextoFIB.intento_bloqueado_hoy; }
                    if (contextoFIB.cuentaFIB) { clienteactivo.cuentaFIB = contextoFIB.cuentaFIB; }
                    if (contextoFIB.fallaFIB && String(contextoFIB.fallaFIB).startsWith('TECH-')) {
                        this.localSave.set('fallaOriginalTech', contextoFIB.fallaFIB);
                    } else {
                        this.localSave.delete('fallaOriginalTech');
                    }
                    this.localSave.delete('fallaModificada');
                }
                const campana = { idcampana: idcampana };
                this.clienteinfo.setcliente(clienteactivo, campana, idagente);
                this.localSave.set('clienteFromFIB', true);
                this.router.navigate(['homeagente/atencioncliente']);
            }
        } catch (err) {
            console.error('CitaTentativaHelperService.openTentativaParaCliente error:', err);
            this.snackbar.open('Error al cargar la tentativa.', 'Cerrar', { duration: 3000 });
        }
    }
}
